import styled from 'styled-components'

export const HeaderCenterWrapper = styled.div`
  display: flex;
  /* 正常搜索栏 */
  .search-base {
    display: flex;
    align-items: center;
    border: 1px solid #eee;
    height: 38px;
    border-radius: 24px;
    padding: 5px;
    ${(props) => props.theme.mixin.boxShadow}

    .text {
      width: 280px;
      padding-left: 15px;
      font-weight: 600;
    }
    .search {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 32px;
      height: 32px;
      background-color: red;
      border-radius: 50%;
      color: #fff;
    }
  }

  /* 激活状态的搜索栏 */
  .search-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;

    overflow: auto;
    /* margin-top: 44px; */

    .search-tabs {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .search-panel-wrap {
      display: flex;
      justify-content: center;
    }
  }

  /* 切换正常、激活搜索栏动画 */
  /* 激活动画 */
  .active-enter {
    transform: scale(0.35, 0.727273) translateY(-58px);
    opacity: 0;
  }
  .active-enter-active {
    transform: scale(1) translateY(0);
    opacity: 1;
    transition: all 250ms ease;
  }
  .active-exit {
    transform: scale(1) translateY(0);
    opacity: 1;

  }
  .active-exit-active {
    transform: scale(0.35, 0.727273) translateY(-58px);
    opacity: 0;
    transition: all 250ms ease;
  }
  /* 正常动画 */
  .base-exit {
    opacity: 0;
  }
  .base-enter {
    transform: scale(2.85714, 1.375) translateY(58px);
    opacity: 0;
  }
  .base-enter-active {
    transform: scale(1) translateY(0);
    opacity: 1;
    transition: all 250ms ease;
  }


`
